import {
    type Path,
    type SlateEditor,
    type Value,
} from '@udecode/plate';

import { BaseFootnotesPlugin } from '../BaseFootnotesPlugin';
import type { TFootnoteElement } from '../types';

export const setFootnoteContents = (
    editor: SlateEditor,
    at: TFootnoteElement|Path,
    contents: Value
) => {
    const type = editor.getType(BaseFootnotesPlugin);

    editor.tf.withoutNormalizing(() => {
        editor.tf.setNodes<TFootnoteElement>({
            footnotes: contents
        }, {
            at,
            match: n => n.type === type,
        });
    });
};
